const contentMapping = {
    '/reports/authentication-performance': {
        title: 'Authentication Performance Reports',
        description: 'Summary of authentication performance metrics including success rates and failure reasons.',
    },
    '/reports/anomaly-detection': {
        title: 'Anomaly Detection Reports',
        description: 'Reports on detected anomalies, their types, and related verification data.',
    },
    '/reports/geolocation-verification': {
        title: 'Geolocation Verification Reports',
        description: 'Reports on geolocation verification results and status.',
    },
    '/reports/product-specific-verification': {
        title: 'Product-Specific Verification Reports',
        description: 'Verification results for specific products, including success counts and regions.',
    },
    '/reports/user-activity': {
        title: 'User Activity Reports',
        description: 'Reports on user actions, types, and timestamps.',
    },
    '/reports/verification-frequency': {
        title: 'Verification Frequency Reports',
        description: 'Reports detailing verification frequency, dates, and user types.',
    },
    // '/reports/audit-trail': {
    //     title: 'Audit Trail Reports',
    //     description: 'Detailed audit trails including user activities and timestamps.',
    // },
    '/reports/alerts-notifications': {
        title: 'Alerts and Notifications Reports',
        description: 'Summary of alerts and notifications generated by the system.',
    },
    '/reports/report-logs-list': {
        title: 'Export Report Logs',
        description: 'Summary of log reports, including when it is generated, its remarks and status.',
    }
};

export default contentMapping;
